import React, { ReactNode, useMemo, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type OverlayContextProps = {
  actions: ReactNode | null;
  setActions: (links: ReactNode | null) => void;
  onClose: () => void;
};
export const OverlayContext = React.createContext<OverlayContextProps>({
  onClose: () => {},
  setActions: () => {},
  actions: null,
});

type OverlayProviderProps = {
  children: React.ReactNode;
  onClose?: () => void;
};
export const OverlayRouteProvider = ({ children, onClose: onCloseOverride }: OverlayProviderProps) => {
  const navigate = useNavigate();
  const [actions, setActions] = useState<ReactNode | null>(null);

  const onClose = () => {
    if (onCloseOverride) {
      onCloseOverride();
      return;
    }
    navigate('..');
  };
  const value = useMemo(() => ({ onClose, actions, setActions }), [actions, onClose, setActions]);

  return <OverlayContext.Provider value={value}>{children}</OverlayContext.Provider>;
};

export const useOverlay = () => React.useContext(OverlayContext);

export const OverlayActions = ({ children }: { children: ReactNode }) => {
  const { setActions: setLinks } = useOverlay();

  useEffect(() => {
    setLinks(children);
    return () => setLinks(null);
  }, [children]);

  return null;
};
